/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { chatSession, conversationTimeout, displayDisconnect, displayDisconnectWarning } from "$lib/stores/chatSessionStore";
import { datadogLogs } from "@datadog/browser-logs";
import { get } from "svelte/store";

let timer = get(chatSession)?.disconnectTimer
const timeout = 15 * 60 * 1000 // 15 minutes
const warningTimeout = 10 * 60 * 1000 // 10 minutes
export const startCreateTimer = (conversation_id: string) => {
    if (!get(chatSession)?.flags?.['conversational-disconnect-logic-enabled']) return;
    stopTimer(conversation_id);
    conversationTimeout.set(false);
    const startTime = Date.now()

    timer = setInterval(() => {
        const timePast = Date.now() - startTime
        if (!get(displayDisconnectWarning) && timePast >= warningTimeout) {
            displayDisconnectWarning.set(true)
        }
        if (timePast >= timeout) {
            displayDisconnectWarning.set(false)
            if (!(get(displayDisconnect))) {
                displayDisconnect.set(true)
            }
            clearInterval(timer as NodeJS.Timeout)
            disconnectConversationLogic()
            timer = null
        }
    }, 60000);
    datadogLogs.logger.info(`[Conv-ui] Timeout started - conversation_id: ${conversation_id}`)
};

export const stopTimer = (conversation_id: string) => {
    if (!get(chatSession)?.flags?.['conversational-disconnect-logic-enabled']) return;
    if (timer) {
        clearInterval(timer as NodeJS.Timeout)
        timer = null
        displayDisconnectWarning.set(false)
        datadogLogs.logger.info(`[Conv-ui] Ended Timeout timer - conversation_id: ${conversation_id}`)
    }
}

const disconnectConversationLogic = async () => {
    displayDisconnectWarning.set(false)
    const chatSessionData = get(chatSession)
    conversationTimeout.set(true);
    chatSession.update((old) => {
        const clearMessageParams = old.messages.map(msg => ({ ...msg, params: {}, }));
        const updatedSession = {
            ...old,
            messages: [
                ...clearMessageParams,
                {
                    sender: 'bot',
                    message: 'Your session has ended due to inactivity. If you still need assistance, feel free to start a new chat.',
                    type: 'text',
                    params: {}
                }
            ],
            chatHistory: old.chatHistory
        };
        sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
        return updatedSession;
    });
    datadogLogs.logger.info(`[Conv-ui] Conversation timeout disconnect - conversation_id: ${chatSessionData.conversation_id} brand: ${chatSessionData.brand}`)

};